export const formatDate = date => {
  let isValidDate = isNaN(Date.parse(date))

  if (isValidDate) {
    return ""
  } else {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} `
  }
}
